module.exports = __webpack_public_path__ + "static/06-2225e8d80fdddd54afd5a31fc5c64f5d.jpg";